/**
 * Created by xxh on 2022/11/25.
 */
export const API_ROOT =
  (process.env.NODE_ENV === 'production')
  ?  (document.location.protocol + '//' + document.location.host + '/')
    : 'http://localhost:88/'
export const IMAGE_ROOT =
  (process.env.NODE_ENV === 'production')
  ? (document.location.protocol + '//' + document.location.host + '/')
      : 'http://localhost:88/'
